export default class IseecooSlideShow extends HTMLElement {
  constructor() {
    super();

    this._slider = null;
    this.initialized = false;

    if (!theme.config.isTouch || Shopify.designMode) {
      Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    } else {
      new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
    }
  }

  static get observedAttributes() {
    return ['selected-data-index'];
  }

  get slider() {
    return this._slider
  }

  get selectedDataIndex() {
    return this.getAttribute('selected-data-index') || null;
  }

  set selectedDataIndex(dataIndex) {
    if (dataIndex) {
      this.setAttribute('selected-data-index', dataIndex);
    } else {
      this.removeAttribute('selected-data-index');
    }
  }

  get items() {
    return Array.from(this.querySelectorAll('[data-index]'));
  }

  get autoplay() {
    return this.hasAttribute('autoplay');
  }

  get speed() {
    return this.hasAttribute('autoplay') ? parseInt(this.getAttribute('autoplay-speed') || '1') * 1000 : 5000;
  }

  get adaptiveHeightProperty() {
    return false;
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    if (this.items.length > 1) {
      const flickityOptions = {
        accessibility: false,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: true,
        rightToLeft: theme.config.rtl,
        autoPlay: this.autoplay ? this.speed : false,
        adaptiveHeightProperty: this.adaptiveHeightProperty,
        on: {
          ready: () => {
            const selectedElement = this._slider ? this._slider.selectedElement : this.items[0];
            this.onReady(selectedElement);
            
            if (selectedElement && selectedElement.getAttribute('data-type') === 'video') {
              const toVideoElement = theme.utils.visibleMedia(selectedElement.querySelectorAll('video-media'));
              toVideoElement && toVideoElement.play();
            }
          },
          change: () => {
            const selectedElement = this._slider?.selectedElement;
            if (selectedElement) {
              const selectedDataIndex = selectedElement?.dataset.index;
              if (this.selectedDataIndex !== selectedDataIndex) {
                this.selectedDataIndex = selectedDataIndex;
                this.dispatchEvent(new CustomEvent('slider:change', { bubbles: true, detail: { currentDataIndex: selectedDataIndex } }));
              }
            }
          }
        },
      };

      if (this.dataset.prevNextButtons) {
        flickityOptions.prevNextButtons = this.dataset.prevNextButtons === 'true';
      }

      if (this.dataset.navFor) {
        flickityOptions.asNavFor = this.dataset.navFor;
      }

      if (this.dataset.draggable) {
        flickityOptions.draggable = this.dataset.draggable === 'true';
      }

      if (this.dataset.percentPosition) {
        flickityOptions.percentPosition = this.dataset.percentPosition === 'true';
      }

      if (this.dataset.groupCells) {
        flickityOptions.groupCells = this.dataset.groupCells;
      }

      if (this.dataset.pageDots) {
        flickityOptions.pageDots = this.dataset.pageDots === 'true';
      }

      if (this.dataset.contain) {
        flickityOptions.contain = this.dataset.contain === 'true';
      }

      this._slider = new Flickity(this, flickityOptions);

      
      this.addEventListener('slider:previous', () => this._slider && this._slider.previous());
      this.addEventListener('slider:next', () => this._slider && this._slider.next());
      this.addEventListener('slider:play', () => this._slider && this._slider.playPlayer());
      this.addEventListener('slider:pause', () => this._slider && this._slider.pausePlayer());

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const selectedElement = event.target;
          if (selectedElement && this.items.includes(selectedElement)) {
            const index = this.items.indexOf(selectedElement);
            this._slider && this._slider.select(index);
          }
        });
      }
    } else if (this.items.length === 1) {
      this.onReady(this.firstChild);
    }
  }

  disconnectedCallback() {
    if (this._slider) this._slider.destroy();
  }


  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'selected-data-index' && oldValue !== newValue) {
      const fromElement = this.items.find(item => item.dataset.index === oldValue);
      const toElement = this.items.find(item => item.dataset.index === newValue);

      if (fromElement && fromElement.getAttribute('data-type') === 'video') {
        const fromVideoElement = theme.utils.visibleMedia(fromElement.querySelectorAll('video-media'));
        fromVideoElement && fromVideoElement.pause();
      }

      if (toElement) {
        const animateElement = toElement.querySelector('animate-element');
        animateElement && animateElement.refresh();

        if (toElement.getAttribute('data-type') === 'video') {
          const toVideoElement = theme.utils.visibleMedia(toElement.querySelectorAll('video-media'));
          toVideoElement && toVideoElement.play();
        }
      }
    }
  }

  select(dataIndex) {
    const indexToSelect = this.items.findIndex(item => item.dataset.index === dataIndex);

    if (indexToSelect !== -1) {
      this._slider && this._slider.select(indexToSelect);
    } else {
      console.warn(`No slide found with data-index: ${dataIndex}`);
    }
  }

  onReady(selectedElement) {
    if (!selectedElement) return;

    if (selectedElement.getAttribute('data-type') === 'video') {
      const videoElement = theme.utils.visibleMedia(selectedElement.querySelectorAll('video-media'));
      videoElement && videoElement.play();
    }

    if (!theme.config.isTouch) {
      const animateElement = selectedElement.querySelector('animate-element');
      animateElement && animateElement.refresh();
    }
  }
}
